import { render, staticRenderFns } from "./DeleteContentOverlay.vue?vue&type=template&id=7ced28ca&"
import script from "./DeleteContentOverlay.vue?vue&type=script&lang=js&"
export * from "./DeleteContentOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ced28ca')) {
      api.createRecord('7ced28ca', component.options)
    } else {
      api.reload('7ced28ca', component.options)
    }
    module.hot.accept("./DeleteContentOverlay.vue?vue&type=template&id=7ced28ca&", function () {
      api.rerender('7ced28ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/contents/DeleteContentOverlay.vue"
export default component.exports